
import EmailInputDecorator from './EmailInputDecorator';

angular.module('edge.platform.decorator', [])
    .config(['$provide', EmailInputDecorator]);